<div class="toast-host" aria-live="polite" aria-relevant="all">
  @for (toast of toastService.toasts(); track toast.id) {
    @let attrs = toastA11y(toast.severity);
    <div
      class="{{ itemClass(toast.severity) }}"
      [@toastSlide]="toast.exiting ? 'out' : 'in'"
      (@toastSlide.done)="onToastAnimationDone($event, toast)"
      [attr.role]="attrs.role"
      [attr.aria-live]="attrs.live"
    >
      <div class="toast-host__body">
        @if (toast.title) {
          <div class="toast-host__title">{{ toast.title }}</div>
        }
        <div class="toast-host__message">{{ toast.message }}</div>
      </div>
      <a
        class="toast-host__close"
        href="#"
        (click)="onCloseToast($event, toast.id)"
        (keydown.space)="onCloseToastKeydown($event, toast.id)"
        [attr.aria-label]="'COMMON.CLOSE' | translate"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
        >
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </a>
    </div>
  }
</div>
